import React from "react";
import styled, { css } from "styled-components";
import { ReactComponent as IncrementIcon } from "@svgr/webpack?-svgo,+titleProp,+ref!../../Icon/Stand-Alone/Add.svg";
import { ReactComponent as DecrementIcon } from "@svgr/webpack?-svgo,+titleProp,+ref!../../Icon/Stand-Alone/Subtract.svg";
import { GridRow, ButtonSecondarySmall } from "../../";
const MAX_DIGITS = 4;
export const IncrementCounter = ({
  value,
  setValue
}) => {
  const isValid = input => {
    if (input.length > MAX_DIGITS) return false;
    return !input.match(/[^0-9]/);
  };

  const increment = () => {
    if (value.length >= MAX_DIGITS) return;
    const newValue = !value ? "1" : (parseInt(value) + 1).toString();
    setValue(newValue);
  };

  const decrement = () => {
    if (value === "0" || !value) {
      setValue("0");
      return;
    }

    const newCounterValue = parseInt(value) - 1;
    setValue(newCounterValue.toString());
  };

  const onChange = e => {
    const input = e.target.value;

    if (!isValid(input)) {
      return;
    }

    setValue(input);
  };

  const zeroPad = val => {
    if (val.length >= MAX_DIGITS) return "";
    const pad = new Array(4 - val.length).fill("O");
    return replaceZeros(pad.join("") + val);
  };

  const replaceZeros = val => {
    const formatted = val.replace(/0/g, "O");
    return formatted;
  };

  return /*#__PURE__*/React.createElement(Container, {
    xCenter: true,
    yCenter: true
  }, value === "0" && /*#__PURE__*/React.createElement(Label, null, /*#__PURE__*/React.createElement(VoteButton, {
    onClick: increment
  }, "Vote")), value !== "0" && /*#__PURE__*/React.createElement(Label, null, /*#__PURE__*/React.createElement(IncrementWrapper, {
    yCenter: true,
    xCenter: true
  }, /*#__PURE__*/React.createElement(Decrement, {
    onClick: decrement,
    tabIndex: "-1"
  }), /*#__PURE__*/React.createElement(InputWrapper, null, /*#__PURE__*/React.createElement(HiddenInput, {
    value: value,
    onChange: onChange
  }), /*#__PURE__*/React.createElement(CounterInput, {
    value: replaceZeros(value),
    onChange: () => {}
  }), /*#__PURE__*/React.createElement(PlaceholderInput, {
    value: zeroPad(value),
    onChange: () => {}
  })), /*#__PURE__*/React.createElement(Increment, {
    onClick: increment,
    tabIndex: "-1"
  }))));
};
const Label = styled.label``;
const CounterInput = styled.input`
  position: absolute;
  width: 100%;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  text-align: right;
  ${props => props.theme.fonts.default}
  font-family: "Overpass Mono", monospace;
  font-size: 16px;
  font-weight: 400;
  border: none;
  outline: 0;
  -webkit-appearance: none;
  color: ${props => props.theme.colors.white};
  background-color: transparent;
  z-index: 1;
`;
const PlaceholderInput = styled(CounterInput)`
  color: ${props => props.theme.colors.disabledText};
  z-index: 0;
  &::selection {
    background: none;
  }
`;
const HiddenInput = styled(CounterInput)`
  z-index: 2;
  color: transparent;
  caret-color: ${props => props.theme.colors.white};
  &::selection {
    color: transparent;
    background: none;
  }
`;
const IncrementWrapper = styled(GridRow)`
  width: 140px;
  border: ${props => props.theme.borders.input};
  border-color: ${props => props.theme.colors.white};
  padding: 2px 0;
  border-radius: 30px;
  background-color: transparent;

  &:focus-within {
    border-color: ${props => props.theme.colors.action};
    box-shadow: 0 0 4px 0 ${props => props.theme.colors.action};
  }
`;
const Container = styled(GridRow)`
  width: 200px;
`;
const iconStyle = css`
  width: 24px;
  height: 24px;
  padding: 0 8px;
  cursor: pointer;
  outline: none;
  path {
    fill: ${props => props.theme.colors.white};
  }

  &:active {
    path {
      stroke: ${props => props.theme.colors.white};
      stroke-width: 3;
      box-shadow: 0 0 4px 0 ${props => props.theme.colors.action};
    }
  }
`;
const Increment = styled(IncrementIcon)`
  ${iconStyle}
`;
const Decrement = styled(DecrementIcon)`
  ${iconStyle}
`;
const InputWrapper = styled.div`
  position: relative;
  background-color: transparent;
  height: 36px;
  width: 40px;
`;
const VoteButton = styled(ButtonSecondarySmall)`
  width: 50px;
  border-color: ${props => props.theme.colors.borderLight};
  background-color: ${props => props.theme.colors.white};
  color: ${props => props.theme.colors.inputText};
`;